export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'kd-theme';

export function getInitialTheme(): Theme {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {
    // Storage unavailable; fall back to the system preference.
  }
  // Light is the default; dark mode only when the visitor chooses it.
  return 'light';
}

export function applyTheme(theme: Theme, animate = false) {
  const root = document.documentElement;
  if (animate) {
    root.classList.add('theme-switching');
    window.setTimeout(() => root.classList.remove('theme-switching'), 220);
  }
  root.classList.toggle('dark', theme === 'dark');
}

export function saveTheme(theme: Theme) {
  try {
    window.localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // Ignore; the choice lasts for this page view.
  }
}
